var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.244,
    cy: 15.5675,
    r: 4.32432,
    transform: "rotate(90 36.244 15.5675)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6221 30L44.6221 2L27.8653 2L27.8653 30L44.6221 30ZM46.6221 2C46.6221 0.895431 45.7266 -3.91404e-08 44.6221 -8.74227e-08L27.8653 -8.19884e-07C26.7607 -8.68166e-07 25.8653 0.89543 25.8653 2L25.8653 30C25.8653 31.1046 26.7607 32 27.8653 32L44.6221 32C45.7266 32 46.6221 31.1046 46.6221 30L46.6221 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5665 30.2703C40.5666 27.8822 42.5025 25.9462 44.8906 25.946L44.8906 30.2703L40.5665 30.2703Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9198 1.72967C31.9198 4.11783 29.9838 6.05383 27.5957 6.05396L27.5957 1.72967L31.9198 1.72967Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9189 30.2703L27.5944 30.2703L27.5944 25.9459C27.5945 25.9459 27.5945 25.9459 27.5946 25.9459C29.9829 25.9459 31.9189 27.882 31.9189 30.2702C31.9189 30.2702 31.9189 30.2703 31.9189 30.2703Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5684 1.72974H44.8929V6.0541C44.8928 6.0541 44.8928 6.0541 44.8927 6.0541C42.5044 6.0541 40.5684 4.11803 40.5684 1.72977C40.5684 1.72976 40.5684 1.72975 40.5684 1.72974Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 8,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 21.2732V31.5H0.0361328C0.547852 24.5112 6.37988 19 13.5 19C16.2754 19 18.8545 19.8374 21 21.2732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersements);
export default __webpack_public_path__ + "static/media/versements.255606b7a8aabd912869e7144ce7f180.svg";
export { ForwardRef as ReactComponent };